import { baseAxios } from "./apiDefault";
import promiseHandler from "@/utils/promise";

export const userService = async type =>
  /*1-> database, 2-> readyAplication, 3-> customApplication*/
  promiseHandler(baseAxios().get(`/user/api/v1.0/service/list/${type}`));

export const deleteUserService = async data =>
  promiseHandler(baseAxios().delete("/user/api/v1.0/service", { data: data }));

export const userMiniServiceList = async type =>
  promiseHandler(
    baseAxios().get(`user/api/v1.0/service/list/identifier/${type}`)
  );

export const checkAppServiceName = async data =>
  promiseHandler(baseAxios().post("user/api/v1.0/service/isUniqueName", data));

export const getUserServiceEnvs = async id =>
  promiseHandler(baseAxios().get(`user/api/v1.0/service/Envs/${id}`));

export const addEnvService = async data =>
  promiseHandler(baseAxios().post(`user/api/v1.0/service/Env`, data));

export const deleteEnvService = async data =>
  promiseHandler(
    baseAxios().delete(`user/api/v1.0/service/Env`, { data: data })
  );

export const getLastServiceVersionId = async nameService =>
  promiseHandler(
    baseAxios().get(`api/v1.0/service/lastVersionId/${nameService}`)
  );

export const createService = async data =>
  promiseHandler(baseAxios().post("user/api/v1.0/service", data));

export const userServiceDetails = async id =>
  promiseHandler(baseAxios().get(`user/api/v1.0/service/details/${id}`));

export const changeServiceStatus = async data =>
  promiseHandler(baseAxios().put("user/api/v1.0/service/status", data));

export const userServiceLogs = async id =>
  promiseHandler(baseAxios().get(`user/api/v1.0/service/logs/${id}`));

export const userServiceStats = async id =>
  promiseHandler(baseAxios().get(`user/api/v1.0/service/stats/${id}`));

export const serviceList = async type =>
  /*1-> database, 2-> readyAplication, 3-> customApplication*/
  promiseHandler(baseAxios().get(`api/v1.0/service/${type}`));

export const createFTP = async data =>
  promiseHandler(baseAxios().post("user/api/v1.0/service/ftp", data));

export const deleteFTP = async data =>
  promiseHandler(
    baseAxios().delete("/user/api/v1.0/service/ftp", { data: data })
  );

export const ftpUserList = async id =>
  promiseHandler(baseAxios().get(`user/api/v1.0/service/ftp/list/${id}`));

export const createFileManager = async data =>
  promiseHandler(baseAxios().post("user/api/v1.0/service/fileManager", data));

export const fileMangerUserList = async id =>
  promiseHandler(
    baseAxios().get(`user/api/v1.0/service/fileManager/list/${id}`)
  );

export const deleteFileManager = async data =>
  promiseHandler(
    baseAxios().delete("user/api/v1.0/service/fileManager", {
      data: data
    })
  );

export const createBackup = async data =>
  promiseHandler(baseAxios().post("user/api/v1.0/service/backup", data));

export const backupUserList = async id =>
  promiseHandler(baseAxios().get(`user/api/v1.0/Service/Backup/List/${id}`));

/*****************************ADMIN****************************/

export const userServiceAdmin = async () =>
  /* 1-> database, 2-> apllications */
  promiseHandler(baseAxios().get(`admin/api/v1.0/userService/list`));

export const userServiceDetailsAdmin = async id =>
  promiseHandler(baseAxios().get(`admin/api/v1.0/UserService/details/${id}`));
